import { io } from 'socket.io-client';
import { getSocketUrl } from './api-url';

const initSocket = () => io(getSocketUrl());

export default initSocket;
